import { IHttpApi } from '@cian/http-api/shared/http';

import {
  createSubscribeModel,
  ISubscribeResponseError,
  ISubscribeRequest,
  ISubscribeResponse,
  TSubscribeResponse,
} from '../repositories/reviews/v1/subscribe';
import {
  createUnsubscribeModel,
  IUnsubscribeResponseError,
  IUnsubscribeRequest,
  IUnsubscribeResponse,
  TUnsubscribeResponse,
} from '../repositories/reviews/v1/unsubscribe';
import { EEntityType } from '../repositories/reviews/entities/web_entities/SubscribeRequestSchema';

export function subscribe(
  httpApi: IHttpApi,
  email: string,
  realtorId: number,
): Promise<ISubscribeResponse | ISubscribeResponseError> {
  return httpApi
    .fetch<ISubscribeRequest, TSubscribeResponse>(
      createSubscribeModel({ email, entityId: realtorId, entityType: EEntityType.Agent }),
    )
    .then((response: TSubscribeResponse) => {
      if (response.statusCode !== 200) {
        throw new Error(response.response.message);
      }

      return response.response;
    });
}

export function unsubscribe(
  httpApi: IHttpApi,
  email: string,
  realtorId: number,
): Promise<IUnsubscribeResponse | IUnsubscribeResponseError> {
  return httpApi
    .fetch<IUnsubscribeRequest, TUnsubscribeResponse>(
      createUnsubscribeModel({
        email,
        entityId: realtorId,
        entityType: EEntityType.Agent,
      }),
    )
    .then((response: TUnsubscribeResponse) => {
      if (response.statusCode !== 200) {
        throw new Error(response.response.message);
      }

      return response.response;
    });
}
